<template>
    <div class="app-inner fixed fixed-head-2">
        <!--/-->
        <div class="app-head">
            <common-header></common-header>
            <common-nav></common-nav>
        </div>
        <!--/-->
        <div class="app-body">
            <my-bscroll>
                <h2 style="text-align: center;padding-top: 50px">修改密码页面</h2>
                <div style="height: 1500px;background: #f1f1f1">&nbsp;222222222222</div>
                <div>ok</div>
            </my-bscroll>
        </div>
    </div>
</template>

<script>
import BScroll from 'better-scroll'
export default {
    methods:{
        loadMore:function(){

        },
    },
    data: function () {
        return {
            busy:false
        }
    },
    mounted:function(){
//        this.foodScroll = new BScroll(this.$refs.r_app_body, {
//            bounce: false,    // 回弹
//            mouseWheel: true, // 鼠标滚轮
//            scrollbar: {      // 滚动条
//                fade: true,
//                interactive:true
//            }
//        });
//        console.log( this.foodScroll);
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/password.vue